import EmptyLayout from '@/views/layouts/EmptyLayout.vue';
import Dashboard from '@/views/modules/core/home/Dashboard.vue';
import Filemanager from '@/views/modules/core/files/MainView.vue';
import Doors from '@/views/modules/core/doors/Doors.vue';
import Preface from '@/views/modules/core/doors/Preface.vue';


export default [
    {
        path: 'dashboard',
        name: 'dashboard',
        meta: { auth: true },
        component: Dashboard
    },
    {
        path: 'preface',
        name: 'preface',
        meta: { auth: true },
        component: Preface
    },
    {
        path: 'doors',
        name: 'doors',
        meta: { auth: true },
        component: Doors
    },
    {
        path: 'characters',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            {
                path: ':path/:id',
                name: 'character1',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/character/Character.vue')
            },
        ]
    },
    {
        // Konto użytkownika
        path: 'account',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            {
                path: 'profile',
                name: 'core-account-profile',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/account/Profile.vue')
            },
            {
                path: 'password',
                name: 'core-account-password',
                meta: { auth: true, stop: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/account/Password.vue')
            },
            {
                path: 'notifications',
                name: 'core-account-notifications',
                meta: { auth: true},
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/account/Notifications.vue')
            }
        ]
    },
    {
        path: 'admin',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            // Użytkownicy
            {
                path: 'users/add',
                name: 'core-users-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/users/UserForm.vue')
            },
            {
                path: 'users/:id',
                name: 'core-users-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/users/UserForm.vue')
            },
            {
                path: 'users/:filterName(\\w+)?/:filterValue(\\d+)?',
                name: 'core-users',
                meta: { auth: true },
                props: true,
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/users/UsersList.vue')
            },
            // Role
            {
                path: 'roles',
                name: 'core-roles',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/roles/RolesList.vue')
            },
            {
                path: 'roles/add',
                name: 'core-roles-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/roles/RoleForm.vue')
            },
            {
                path: 'roles/:id',
                name: 'core-roles-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/roles/RoleForm.vue')
            },
            // Zespoły
            {
                path: 'teams',
                name: 'core-teams',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/teams/TeamsList.vue')
            },
            {
                path: 'teams/add',
                name: 'core-teams-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/teams/TeamForm.vue')
            },
            {
                path: 'teams/:id',
                name: 'core-teams-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/teams/TeamForm.vue')
            },
            // Organizacja
            {
                path: 'units',
                name: 'core-units',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/organization/UnitsList.vue'),
                children: [
                    {
                        path: 'add',
                        props: true,
                        name: 'core-units-add',
                        meta: { auth: true },
                        component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/organization/UnitForm.vue')
                    },
                    {
                        path: ':id',
                        props: true,
                        name: 'core-units-edit',
                        meta: { auth: true },
                        component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/organization/UnitForm.vue')
                    }
                ]
            },
            // Bezpieczeństwo
            {
                path: 'security',
                name: 'core-security',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/security/MainForm.vue')
            },
            // Historia logowania
            {
                path: 'authlog',
                name: 'core-authlog',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/authlog/AuthlogList.vue')
            },
            // Rejestr zmian
            {
                path: 'changelog/:sessionId(\\d+)?',
                name: 'core-changelog',
                meta: { auth: true },
                props: true,
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/changelog/ChangesList.vue')
            },
            {
                path: 'changelog/diff/:id(\\d+)?',
                name: 'core-changelog-diff',
                meta: { auth: true },
                props: true,
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/changelog/ChangesView.vue')
            },
            // Zastępstwa
            {
                path: 'substitutions/add',
                name: 'core-substitutions-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/substitution/SubstitutionForm.vue')
            },
            {
                path: 'substitutions/:id',
                name: 'core-substitutions-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/substitution/SubstitutionForm.vue')
            },
            {
                path: 'substitutions/:filterName(\\w+)?/:filterValue(\\d+)?',
                name: 'core-substitutions',
                meta: { auth: true },
                props: true,
                component: () => import(/* webpackChunkName: "core" */ '@/views/modules/core/substitution/SubstitutionList.vue')
            },
        ]
    },
    {
        path: 'filemanager',
        name: 'filemanager',
        meta: { auth: true },
        component: Filemanager
    },
];
